import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import {
  Button,
  CircularProgress,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [lista, setLista] = useState([]);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    api
      .get("vouchersFreteGratis/listar")
      .then((res) => {
        setLista(res);
      })
      .catch((err) => {
        notification(
          "error",
          "Erro ao listar os vouchers de frete disponíveis."
        );
      });
  };

  const excluir = (params) => {
    api
      .delete("vouchersFreteGratis/excluir", {
        id: params.id,
      })
      .then((res) => {
        notification("success", "Voucher excluido!");
        carregar();
      })
      .catch((err) => notification("error", "Erro ao excluir voucher"));
  };

  const tRegistros = {
    title: "Vouchers de frete grátis",
    newItemAction: () => history.push("/app/voucher-frete-gratis/geracao"),

    columns: [
      {
        name: "escolaNome",
        label: "Escola",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "validade",
        label: "Validade",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "geracao",
        label: "Gerado em",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "anotacao",
        label: "Anotação",
        options: {
          filter: false,
          sort: false,
        },
      },
    ],
    actions: [
      {
        name: "remover",
        icon: "zmdi zmdi-delete",
        tooltip: "Remover",
        title: "Excluir",
        action: excluir,
      },
    ],
    array: lista,
  };

  return (
    <div>
      <br />
      {/* <ThemeProvider theme={theme}>
        <Button
          style={{ margin: "0px 10px 0px 10px" }}
          variant="contained"
          sx={{ color: "#FFFF" }}
          onClick={() => history.push("/app/voucher-frete-gratis/geracao")}
        >
          Gerar voucher
        </Button>
      </ThemeProvider>
      <br />
      <br /> */}

      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
